import { AxiosResponse } from 'axios';
import { api } from '../../../../api/axiosInstance';
import { UrlRankRepository } from '../../Domain/Repositories/UrlRankRepository';
import {
  UrlRankJobAccepted,
  UrlRankJobStatus,
  UrlRankRequest,
  UrlRankStartResult,
  UrlRankStoredResponse,
} from '../../Model/UrlRank';

export class UrlRankRepositoryImpl implements UrlRankRepository {
  async startUrlRank(request: UrlRankRequest): Promise<UrlRankStartResult> {
    const body: Record<string, unknown> = {
      keyword: request.keyword,
      product_url: request.product_url,
    };
    if (request.force_refresh) {
      body.force_refresh = true;
    }

    const response: AxiosResponse<UrlRankStoredResponse | UrlRankJobAccepted> = await api.post(
      '/utils/url-rank/',
      body
    );

    if (response.status === 202 || (response.data as UrlRankJobAccepted).job_id) {
      return { kind: 'job', data: response.data as UrlRankJobAccepted };
    }

    return { kind: 'stored', data: response.data as UrlRankStoredResponse };
  }

  async getUrlRankJob(jobId: string): Promise<UrlRankJobStatus> {
    const response: AxiosResponse<UrlRankJobStatus> = await api.get(
      `/utils/url-rank/${jobId}/`
    );
    return response.data;
  }
}
